@if (navigation) { @if (!(['xs', 'sm', 'md'] | breakpoint | async) &&
navigation) {
<button mat-button [matMenuTriggerFor]="obtainedMenu">
  <mat-icon>directions_car</mat-icon>
  {{ title() }}
</button>
<cec-menu-item
  [items]="rootItems"
  (onReturnTrigger)="onTrigger($event)"
  (onItemClicked)="onClickItem($event)"
>
</cec-menu-item>
} @else {
<mat-expansion-panel [class.mat-elevation-z0]="true">
  <mat-expansion-panel-header>
    <div class="list-item">
      <mat-icon>directions_car</mat-icon>
      {{ title() }}
    </div>
  </mat-expansion-panel-header>
  <cec-menu-item
    [items]="rootItems"
    (onItemClicked)="onClickItem($event)"
  ></cec-menu-item>
</mat-expansion-panel>
} }
